module.exports = __webpack_public_path__ + "img/stu-pre-exam-bg-right.2a18c2dd.svg";